//Mobile Nav Function

var nav = function() {

   $('.mobile-menu-btn button').on('click', function(e) {
     if ($('body').hasClass('menu-open')){
       $('body').removeClass('menu-open')
     }
     else{
       $('body').addClass('menu-open')
     }
   });

   $('.mobile-nav a, .logo').on('click', function(e) {
       setTimeout(function(){ $('body').removeClass('menu-open') }, 1000);
   });

   $(window).resize(function() {
       if ($(window).width() > 767) {
          $('body').removeClass('menu-open')
       }
      else {
         //nutin
      }
    });

    $('.mobile-nav__item').click(function(){
      $('body').removeClass('menu-open');
      //alert('hey');
    });

}

export default nav;



// WEBPACK FOOTER //
// ./source/scripts/modules/nav.js